import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Documento } from '../../models/Document';
import { ServidorPublico } from '../../models/ServidorPublico';
import { AccionTarea } from '../../models/Tarea';
import { UnidadOrganizacional } from '../../models/UnidadOrganizacional';
import { AppTitleService } from '../../services/app-title.service';
import { AuthService } from '../../services/auth.service';
import { DocumentoService } from '../../services/documento.service';
import { DateService } from '../../shared/date.service';
import { ScnackbarData, SnackbarStyles, ToastService } from '../toast.service';
import { TareaService } from '../../services/tarea.service';
import { UtilService } from '../../services/util.service';
import { TableSelectedDocumentsComponent } from "../table-selected-documents/table-selected-documents.component";

@Component({
    selector: 'app-archivar',
    imports: [
        MatTableModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        TableSelectedDocumentsComponent
    ],
    templateUrl: './archivar.component.html',
    styleUrl: './archivar.component.scss'
})
export class ArchivarComponent {
  taskData: number[];
  fetchingArchivar = false;
  utilService = inject(UtilService)

  currentUserID: string
  documentsInformation: Documento[] = []

  commentFormGroup = new FormGroup({
    comment: new FormControl("", {
      validators: [
        Validators.required,
        Validators.maxLength(255)
      ]
    })
  })
  participantes: ServidorPublico[] = []
  participantesFiltered?: Observable<ServidorPublico[]>

  departamentos: UnidadOrganizacional[] = []
  departamentosFiltered?: Observable<UnidadOrganizacional[]>

  snackbarData: ScnackbarData = {}
  minDate = new Date(new Date().setDate(new Date().getDate() + 1))

  constructor(
    private router: Router,
    private documentoService: DocumentoService,
    private tareaService: TareaService,
    private toast: ToastService,
    private authService: AuthService,
    private dateService: DateService,
    private location: Location
  ) {
    inject(AppTitleService).setTitle("Archivar");

    const navigation = this.router.getCurrentNavigation();
    if (!navigation) {
      location.back()
    }
    this.taskData = navigation?.extras.state?.["documentIDs"]

    this.taskData.forEach((id) => {
      this.documentoService.getById(id).subscribe({
        next: (response) => {
          this.documentsInformation = [...this.documentsInformation, response]
        }
      })
    })
    this.currentUserID = this.authService.getTokenData()!.id;
  }

  ngOnInit(): void {
  }

  onCrearComentarioSubmit() {
    this.fetchingArchivar = true
    let accionTareas: AccionTarea[] = []
    const comment = this.commentFormGroup.controls.comment.value
    this.documentsInformation.forEach(document => {
      const accionTarea: AccionTarea = {
        id: document.idTarea,
        idParticipante: Number.parseInt(this.currentUserID),
        fechaExpira: this.dateService.formatDateToCustomString(new Date()),
        comentario: comment!
      }
      accionTareas.push(accionTarea)
    });

    this.tareaService.ArchivarDocumento(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Documento archivado"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingArchivar = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        this.location.back()
      },
      error: (_) => {
        this.snackbarData.message = "Error al archivar documento"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingArchivar = false
        this.toast.show(this.snackbarData)
      }
    })
  }


  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onCancel() {
    this.location.back()
  }

}
